export default __webpack_public_path__ + "static/media/sitemap.96cfcc2d.png";